import { GroundType } from 'models/ground';
import React from 'react';
import { Group, Line } from 'react-konva';
import { DEFAULT_PITCH_LINE_COLOR, DEFAULT_PITCH_STROKEWIDTH } from '../constants';
import Vertices from '../Vertices';
import { GroundGeometry } from '../../../../types/webPlayer';

export default function Tennis( props: {
  groundData: GroundType;
  scale: number;
  vertices: boolean;
  groundGeometry: GroundGeometry;
} ) {
  const {groundData, vertices, groundGeometry, scale} = props;
  const {dims, vertex, center} = groundGeometry;
  const {width} = dims;

  const {
    vertexA,
    vertexB,
    vertexC,
    vertexD,
  } = vertex;

  return (
    <Group>
      {vertices ? <Vertices A={vertexA} C={vertexC} /> : null}

      {/* OUTER COURT (DOUBLES) */}
      <Line
        fill={groundData.groundSurfaceColor ? groundData.groundSurfaceColor : '#00000000'}
        points={[
          vertexA.x, vertexA.y,
          vertexB.x, vertexB.y,
          vertexC.x, vertexC.y,
          vertexD.x, vertexD.y
        ]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
        closed
      />

      {/* SINGLES SIDELINES */}
      <Line
        points={[
          vertexA.x, vertexA.y - 1.37 * scale,
          vertexD.x, vertexD.y - 1.37 * scale,
        ]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Line
        points={[
          vertexB.x, vertexB.y + 1.37 * scale,
          vertexC.x, vertexC.y + 1.37 * scale,
        ]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />

      {/* NET */}
      <Line
        points={[
          center.x, vertexA.y,
          center.x, vertexC.y,
        ]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />

      {/* SERVICE LINES */}
      <Line
        points={[
          vertexA.x - 5.48 * scale, vertexA.y - 1.37 * scale,
          vertexA.x - 5.48 * scale, vertexC.y + 1.37 * scale,
        ]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Line
        points={[
          vertexC.x + 5.48 * scale, vertexA.y - 1.37 * scale,
          vertexC.x + 5.48 * scale, vertexC.y + 1.37 * scale,
        ]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />

      {/* CENTER SERVICE LINE */}
      <Line
        points={[
          vertexA.x - 5.48 * scale, center.y,
          vertexC.x + 5.48 * scale, center.y,
        ]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />

      {/* CENTER MARKS */}
      <Line
        points={[
          vertexA.x, center.y,
          vertexA.x - 0.2 * scale, center.y,
        ]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Line
        points={[
          vertexC.x, center.y,
          vertexC.x + 0.2 * scale, center.y,
        ]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
    </Group>
  );
}
